import React, { useCallback } from 'react';

import classNames from 'classnames';

import { WithTooltip } from '@travauxlib/shared/src/components/DesignSystem/components/WithTooltip';

import { ActionListIconContainer } from './ActionListIconContainer';
import { determineBgColor, determineSize } from './utils/styleHelper';

import { Avatar } from '../Avatar';

import type { ActionItemType } from './type';

type Props = {
  closeActionList?: () => void;
  small?: boolean;
} & ActionItemType;

export const ActionItem: React.FC<Props> = ({
  icon,
  avatar,
  label,
  customLabel,
  onClick,
  closeActionList,
  disabled,
  disabledMessageTooltip,
  small,
  active,
  selected,
  suffix,
}) => {
  const refinedOnClick = useCallback(() => {
    onClick();
    closeActionList?.();
  }, [onClick, closeActionList]);

  return (
    <WithTooltip
      position="right"
      trigger={
        <button
          type="button"
          disabled={disabled}
          onClick={refinedOnClick}
          className={classNames(
            'flex gap-xxs py-xs pr-sm pl-[0.85rem] text-primary hover:action-bg-neutral-weak-hover active:action-bg-neutral-weak-pressed w-full outline-none',
            customLabel ? 'min-h-[40px] items-start' : 'max-h-[40px] items-center',
            determineBgColor(selected, active),
            determineSize(small),
            {
              'action-bg-neutral-weak-disabled! text-disabled! hover:action-bg-neutral-weak-disabled! active:action-bg-neutral-weak-disabled!':
                disabled,
            },
          )}
        >
          {customLabel ? (
            <div>{customLabel}</div>
          ) : (
            <>
              {icon && (
                <ActionListIconContainer small={small} disabled={disabled}>
                  {icon}
                </ActionListIconContainer>
              )}
              {avatar && (
                <ActionListIconContainer small={small} disabled={disabled}>
                  <Avatar {...avatar} size={avatar.size || 'sm'} />
                </ActionListIconContainer>
              )}
              <span className={classNames('truncate text-b2', { 'text-b3': small })}>{label}</span>
              {suffix && <div className="ml-auto">{suffix}</div>}
            </>
          )}
        </button>
      }
    >
      {disabled && disabledMessageTooltip ? <>{disabledMessageTooltip}</> : undefined}
    </WithTooltip>
  );
};
